import { render } from "./TankSurveyVengurla.vue?vue&type=template&id=ff2bca48"
import script from "./TankSurveyVengurla.vue?vue&type=script&lang=js"
export * from "./TankSurveyVengurla.vue?vue&type=script&lang=js"

import "./TankSurveyVengurla.vue?vue&type=style&index=0&id=ff2bca48&scooped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__